import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { fetchAndStorePermissions } from "../utils/checkPermission";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const login = async (userData) => {
    localStorage.setItem("token", userData.token.split("|")[1]);
    localStorage.setItem("id", userData.id);

    setUser(userData);
    setIsAuthenticated(true);
    setIsLoading(false);
    await loadPermissions();
  };

  const logout = async () => {
    try {
      await axiosInstance.post(`${process.env.REACT_APP_API_URL}/logout`);

      localStorage.removeItem("token");
      localStorage.removeItem("id");
      localStorage.removeItem("permissions");

      setUser(null);
      setIsAuthenticated(false);
      setIsLoading(false);
      setPermissions([]);
    } catch (error) {}
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const id = localStorage.getItem("id");

    if (token && id) {
      const fetchUserData = async () => {
        try {
          const response = await axiosInstance.get(
            `${process.env.REACT_APP_API_URL}/users/${id}`,
          );

          if (response.status === 200) {
            const userData = response.data.user;
            setUser(userData);
            setIsAuthenticated(true);
            await loadPermissions();
          } else {
            logout();
          }
        } catch (error) {
          logout();
        } finally {
          setIsLoading(false);
        }
      };

      fetchUserData();
      fetchAndStorePermissions();
    } else {
      setIsLoading(false);
    }
  }, []);

  const loadPermissions = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/user-permissions`,
      );
      const permissionNames = response.data.map(
        (permission) => permission.name,
      );
      localStorage.setItem("permissions", JSON.stringify(permissionNames));
      setPermissions(permissionNames);
    } catch (error) {}
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated,
    permissions,
    isLoading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
